import { FC } from 'react';
import { Text } from '@react-pdf/renderer';

import { styles } from './styles';

type DisplayPlaceholderProps = {
  text?: string | null;
  placeholder: string;
};

export const DisplayPlaceholder: FC<DisplayPlaceholderProps> = ({ text, placeholder }) => {
  if (text) return text;
  return <Text style={styles.placeholder}>[{placeholder}]</Text>;
};
